import { dateTimeConstants } from 'constants/index';
import dayjs from 'dayjs';
import { IApiPagination, IPageInfo, ITimesheetParams } from 'interfaces';
const DEFAULT_PAGINATION: IApiPagination = {
  currentPage: 1,
  pageSize: 10,
  totalItems: 0,
};
const DEFAULT_PAGE: IPageInfo = {
  page: 1,
  pageSize: 10,
};

const DEFAULT_TIMESHEET_PARAMS: ITimesheetParams = {
  page: DEFAULT_PAGINATION.currentPage,
  pageSize: DEFAULT_PAGINATION.pageSize,
  toDate: dayjs(new Date())
    .endOf('day')
    .format(dateTimeConstants.DATE_DASH_ISO_FORMAT),
  fromDate: dayjs(new Date())
    .subtract(1, 'months')
    .add(1, 'days')
    .startOf('day')
    .format(dateTimeConstants.DATE_DASH_ISO_FORMAT),
};
export default {
  DEFAULT_PAGINATION,
  DEFAULT_TIMESHEET_PARAMS,
  DEFAULT_PAGE,
};
